import { makeStyles } from "@mui/styles";

const styles = makeStyles(() => {
    return {
        avatar: {
            marginTop: "calc(100%/10)",
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        notificationMain: {
            display: 'grid',
            placeItems: 'center',
            justifyContent: 'center',
            backgroundColor: "#FAF2D9",
        },
        notificationList: {
            height: "9vh",
            overflow: 'hidden',
            overflowY: 'scroll',
            scrollBehavior: "smooth",
            border: "#37DBDE 2px solid",
            borderRadius: '25px',
            backgroundColor: "transparent",
            "&:hover": {
                height: "10vh",

            }
        }
    }
})
export default styles;